// API utility functions
export const getBackendUrl = () => {
  // In deployment, use relative paths. In development, use the full URL
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  return backendUrl || ''; // Empty string means same domain
};

export const buildApiUrl = (endpoint) => {
  const baseUrl = getBackendUrl();
  // Remove leading slash from endpoint if present, then ensure it starts with /api
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  const apiEndpoint = cleanEndpoint.startsWith('api') ? `/${cleanEndpoint}` : `/api/${cleanEndpoint}`;
  // Remove trailing slash from baseUrl if present
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  return cleanBaseUrl + apiEndpoint;
};